import { useMemo } from "react";
import type { SelectionKey } from "common/utils/accessibilitySelection";
import {
  selectionDisplayCount,
  splitStepFreeAlternatives,
  type FilterSectionLike,
} from "@/lib/accessibilityFilterState";
import { useFilterSheetSections } from "@/hooks/useFilterSheetSections";

/**
 * The badge count for an accessibility selection, over the sections the filter panel draws.
 *
 * @param keys The selection.
 * @param sections The list the caller hands its own panel; omitted, the filter sheet's.
 * @returns The panel's ticked boxes summed over its sections, plus one per key it cannot draw.
 */
export function useAccessibilitySelectionCount(keys: SelectionKey[], sections?: FilterSectionLike[]): number {
  const sheet = useFilterSheetSections();
  const given = useMemo(() => (sections ? splitStepFreeAlternatives(sections) : null), [sections]);
  const { preparedData, tagsToAdd } = given ?? sheet;

  return useMemo(() => selectionDisplayCount(keys, preparedData, tagsToAdd), [keys, preparedData, tagsToAdd]);
}
